<template>
  <div class="gp-main-body-content">
    <TrialTooltipPlanVue from="subpages" :class="'mb-3'" />

    <div id="subpages">
      <div v-if="!isEmptyPagesList">
        <Portal to="headerActions" v-if="inRoute">
          <div class="create-buttons" v-if="!group_selected && ['subpages', 'articlepages', 'homepages', 'productpages', 'collectionpages'].includes(type)">
            <div v-if="['subpages', 'articlepages', 'homepages'].includes(type)" class="create-group d-flex mr-1 clickable" v-popover:tooltip.bottom="$t('group.create')" @click="openModalV2('newGroup')">
              <i class="icon icon-group-add"></i>
            </div>
            <ButtonCreatePage @onClickTemplatePage="onClickTemplatePage" :type="type" />
          </div>
          <div class="add-pages" v-else>
            <ButtonAddPages @onClickTemplatePage="onClickTemplatePage" @onClickAddPages="onClickAddPages" />
          </div>
        </Portal>

        <div class="section">
          <div class="bar d-flex justify-content-between flex-fill">
            <GpTabs @tabChange="onTabChangeHandler" :active="currentTabIndex">
              <template v-slot:GpTab="{ activeIndex, handler }">
                <template v-if="['subpages', 'articlepages', 'homepages'].includes(type)">
                  <template v-if="!group_selected">
                    <div class="page-tab">
                      <GpTab to="#" :index="0" :activeIndex="activeIndex" @click="handler" aClass="mr-3 no-border-with-hover">{{ type == "homepages" ? $tc("generals.template", 2) : $tc("page.page", 2) }}</GpTab>
                      <GpTab to="#" :index="1" :activeIndex="activeIndex" @click="handler" aClass="no-border-with-hover"> {{ $tc("group.group", 2) }}</GpTab>
                    </div>
                  </template>
                  <template v-else>
                    <div class="row">
                      <div class="typo-h5 flex-v-center breadcrumb row px-3">
                        <a class="rl clickable typo-heading16 typo-medium" @click="backToGroups">{{ $tc("group.group", 2) }}</a>
                        <i class="icon icon-arrow-right"></i>
                        <span class="typo-heading16 typo-medium mr-1 breadcrumb-groupname">{{ group_selected.name }}</span>
                        <GroupSettingsDropdown @onUngroupSuccess="onUngroupSuccess" iClass="typo-icon-16" gClass="group-settings" :pageType="type" :group="group_selected" :disableUngroup="disableUngroup" />
                        <!-- Checkpoint -->
                      </div>
                    </div>
                  </template>
                </template>
                <template v-else>
                  <div class="d-flex align-items-center">
                    <h2 class="typo-heading16 typo-medium text-light-high">{{ $tc("generals.template", 2) }}</h2>
                  </div>
                </template>
                <div class="tab ml-auto">
                  <div class="tab-item text-secondary3 d-flex">
                    <div class="page-filter">
                      <FilterPage @onClickFilter="onClickFilter" lclass="dropdown" :type="filterType" />
                    </div>
                    <div class="page-search">
                      <GpInputSearch v-if="currentTabIndex == 1" v-model="queryGroup" :placeholder="$t('group.searchGroup')" />
                      <template v-else>
                        <GpInputSearch v-if="['subpages', 'articlepages', 'homepages'].includes(type)" @onChange="queryPages" v-model="queryPage" :indicating="indicatingSearchPage" :placeholder="$t('page.searchPage', { type: '' })" />
                        <GpInputSearch v-else @onChange="queryPages" v-model="queryPage" :indicating="indicatingSearchPage" :placeholder="$t('page.searchPage', { type: ', ' + $tc(`page.${type.replace('pages', '')}`, 2) })" />
                      </template>
                    </div>
                  </div>
                </div>
              </template>

              <!-- List -->
              <template v-slot:GpTabContent="{ activeIndex }">
                <div class="subpage-body">
                  <LimitationPublishPage :page="type" />
                  <GpTabContent name="Pages" :index="0" :activeIndex="activeIndex">
                    <div class="d-flex justify-content-between">
                      <div class="list-pages mt-3 flex-grow-1">
                        <template v-if="loadingList">
                          <GpListLoading :quantity="20" />
                        </template>

                        <GpList v-else>
                          <template v-slot:GpListItem>
                            <Noti v-if="messageEditShopify" type="warn" variant="toast" :isClose="true" @onClose="messageEditShopify = false" :htmlDesc="openOriginalMessage" class="mb-3"> </Noti>
                            <GpListItem
                              class="page-item d-flex justify-content-between align-items-center mb-3"
                              :class="{
                                'selected-border': isOpenRightSection && selectedBorder(item) && ['collectionpages'].includes(type),
                                'no-select-hover': !['productpages', 'collectionpages'].includes(type),
                                '--just-updated': item.__justUpdated,
                                'disabled-when-campaign': item.runningCampaignId > 0
                              }"
                              :templateList="currentPageType.list"
                              :total="totalItems"
                              v-for="(item, index) in sortedPages"
                              :key="item.id + '_' + index"
                              :page="item"
                              :pageType="type"
                              :listType="['productpages', 'collectionpages'].includes(type) ? 'productCollectionPages' : ''"
                              :loadingList="loadingListRightSection"
                              :currentPage="pagination.page"
                              :img="img"
                              :isOpenRightSection="isOpenRightSection"
                              :pageDefaultTitle="pageDefaultTitle"
                              @openEditor="openEditor"
                              @preventOpenEditor="preventOpenEditor"
                              @makedDefault="makedDefault"
                              @loadAssign="reloadAssigns"
                              @click="onClickGpListItem(item)"
                              @hover="hoverRemoveUpdated"
                            />
                            <Pagination :paginationParam.sync="pagination" :total.sync="totalPagesPagination" @page="toPage" v-if="totalPages > pagination.limit" />
                          </template>
                        </GpList>

                        <GpEmptyPage :customContent="true" :page="type" v-if="query != '' && ['productpages', 'collectionpages'].includes(type) && (!currentTypePages || !currentTypePages.length)">
                          <template #button></template>
                          <template #content>
                            <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">{{ $t("search.noResult", { keyword: query }) }}</p>
                            <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("page.searchEmpty") }}</p>
                          </template>
                        </GpEmptyPage>
                      </div>
                      <AssignProductModal v-if="isOpenRightSection && ['productpages'].includes(type)" :pageInfo="selectedTemplate" @close="() => (isOpenRightSection = false)" @loadAssign="reloadAssigns" />
                      <template v-else-if="['collectionpages'].includes(type) && isOpenRightSection">
                        <template v-if="loadingListRightSection">
                          <GpListLoading type="rightsection" :quantity="7" />
                        </template>
                        <RightSection ref="rightSection" :type="type" :selectedTemplate="selectedTemplate" :pages="currentPageTypeList" @closeRightSection="closeRightSection" v-else @close:add="reloadAssigns()" />
                      </template>
                    </div>
                  </GpTabContent>
                  <GpTabContent name="Groups" :index="1" :activeIndex="activeIndex">
                    <template v-if="loadingList">
                      <GpListLoading type="filter-search" />
                    </template>
                    <template>
                      <GroupList :groups="groupsTransform" @onUngroupSuccess="onUngroupSuccess" @onClickGroupItem="onClickGroupItem" @onClickCreateNew="openModalV2('newGroup')" :pageType="type" />
                      <Pagination :paginationParam.sync="groupPagination" :total.sync="totalGroupsPagination" @page="toPageGroup" v-if="groups(type).length > groupPagination.limit" />
                      <!-- <GpEmptyPage :customContent="true" :page="type" v-if="queryGroup != '' &&  (!groupsTransform || !groupsTransform.length)">
                      <template #button></template>
                      <template #content>
                        <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">
                          {{ $t("page.noType", { type: $tc(`group.group`, 1) }) }}
                        </p>
                        <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("page.searchEmpty") }}</p>
                      </template>
                    </GpEmptyPage>-->
                    </template>
                  </GpTabContent>
                </div>
              </template>
            </GpTabs>
          </div>
        </div>
      </div>

      <!-- Search Empty Page -->
      <GpEmptyPage :customContent="true" :customTitle="true" :page="type" v-if="query != '' && !['productpages', 'collectionpages'].includes(type) && (!currentTypePages || !currentTypePages.length)">
        <template #button></template>
        <template #content>
          <p class="typo-heading24 typo-semibold text-center text-light-high mb-1">
            {{
              $t("search.noResult", {
                keyword: query
              })
            }}
          </p>
          <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("page.searchEmpty") }}</p>
        </template>
      </GpEmptyPage>

      <!-- Empty Page -->
      <GpEmptyPage :page="type" v-if="isEmptyPagesList">
        <template #button>
          <ButtonCreatePage @onClickTemplatePage="onClickTemplatePage" :type="type" />
        </template>
      </GpEmptyPage>

      <GpEmptyPage customContent customTitle page="group" v-if="queryGroup && !group_selected && (!groupsTransform || !groupsTransform.length)">
        <template #button></template>
        <template #content>
          <h1 class="typo-heading24 typo-semibold text-light-high mb-1 text-center">
            {{
              $t("search.noResult", {
                keyword: queryGroup
              })
            }}
          </h1>
          <p class="typo-paragraph14 typo-regular text-light-low text-center">{{ $t("group.searchEmpty") }}</p>
        </template>
      </GpEmptyPage>

      <GpEmptyPage v-if="currentTabIndex == 1 && queryGroup == '' && (!groups(type) || !groups(type).length)" :page="'group'">
        <template #button>
          <button class="btn btn-lg btn-primary m-auto" @click="openModalV2('newGroup')">
            <i class="icon icon-plus mr-1"></i>
            {{ $t("group.createNew") }}
          </button>
        </template>
      </GpEmptyPage>

      <GpEmptyPage page="addPages" v-if="queryPage == '' && group_selected && sortedPages.length == 0">
        <template #button>
          <ButtonAddPages @onClickTemplatePage="onClickTemplatePage" @onClickAddPages="onClickAddPages" />
        </template>
      </GpEmptyPage>

      <!-- /===== Start Modal Create New Group =====/ -->
      <ModalCommon @cancel="closeModalV2('newGroup')" classs="gf_modal-sm" v-else-if="isModalActiveV2('newGroup')" :hideExit="false">
        <template #header>
          <div class="gp_modal-container_header__title">{{ $t("group.createNew") }}</div>
        </template>
        <template #default>
          <div class="share-container">
            <Notification class="mb-2" type="infor" :htmlDesc="$t('group.descTitle')"> </Notification>
            <div>
              <InputField ref="inputTitle" @update:value="newValue => (groupName = newValue)" v-model="groupName" :placeholder="$t('createNewGroup.placeholder')" :clear="false" txtLabel="Group’s name" />
            </div>
            <p v-if="alertText" class="typo-paragraph12 typo-italic text-danger mt-half">{{ alertText }}</p>
          </div>
        </template>
        <template #footer>
          <div class="gf_btn__action-group">
            <button class="btn gf_btn__action btn-outline" @click="closeModalV2('newGroup')">{{ $t("generals.cancel") }}</button>
            <template>
              <ProcessButton class="btn gf_btn__action btn-primary ml-1" :status.sync="btnStatus" @click="createNewGroup" type="submit">
                <template #loading>{{ $t("generals.loading") }}...</template>
                <template #success>{{ $t("generals.success") }}</template>
                <template #error>{{ $t("generals.error") }}</template>
                <template #default>{{ $t("generals.create") }}</template>
              </ProcessButton>
            </template>
          </div>
        </template>
      </ModalCommon>
      <!-- /===== End Modal Create New Group =====/ -->

      <!-- Modal Add Pages -->
      <Modal :hideExit="true" @cancel="closeModalAddPages" v-if="isModalActiveV2('addPages')" cClass="mnw848">
        <template #header>
          <h1 class="typo-heading20 typo-medium text-light-high">{{ $t("group.addPage") }}</h1>
        </template>
        <template #default>
          <GpInputSearch ref="input" :clear="true" v-model="querySearchPage" @onChange="onChangeSearchAddPages" :placeholder="$t('group.inputSearchPlaceholder')" />
          <template>
            <div class="d-flex align-items-center justify-content-between mt-3 mb-2">
              <p class="typo-button14 typo-medium text-light-high">{{ $t("group.selectPages") }}</p>
              <div class="page-filter p-0 pt-half pl-half pb-half">
                <FilterPage @onClickFilter="onClickFilterAddPages" lclass="dropdown" :type="filterType" />
              </div>
            </div>
            <div class="col-12 p-0">
              <GpList :listType="listType" @doLoadMore="doLoadMore">
                <template v-slot:GpListItem>
                  <GpListItem :total="totalItems" class="page-item d-flex justify-content-between align-items-center mb-3 no-select-hover" v-for="(item, index) in allPagesAdd" :key="item.id + '_' + index" :page="item" :pageType="type" :listType="listType" @checkedUpdate="checkedUpdate" :isChecked="isChecked(item)" :img="img" />
                </template>
              </GpList>
            </div>
          </template>
        </template>
        <template #footer>
          <div class="btn-group flex-row-reverse">
            <template>
              <ProcessButton class="btn btn-primary ml-2" @click="submitAddPages" :status.sync="btnStatus" type="submit">
                <template #loading>{{ $t("generals.loading") }}...</template>
                <template #success>{{ $t("generals.success") }}</template>
                <template #error>{{ $t("generals.error") }}</template>
                <template #default>{{ $t("group.addPage") }}</template>
              </ProcessButton>
            </template>

            <button class="btn btn btn-outline" @click="closeModalAddPages">{{ $t("generals.cancel") }}</button>
          </div>
        </template>
      </Modal>

      <!-- Modal Confirm Add Pages -->
      <Modal :hideExit="true" @cancel="closeModalConfirmAddPages" v-if="isModalActiveV2('confirmAddPages')" cClass="mw424">
        <template #header>
          <h1 class="typo-heading20 typo-medium text-light-high">&quot;{{ $t("group.addPage") }}&quot;&nbsp;{{ $t("generals.confirmation") }}</h1>
        </template>
        <template #default>
          <template>
            <p class="typo-paragraph14 typo-regular-150 text-light-low">{{ $t("group.addPageConfirmDesc") }}</p>
          </template>
        </template>
        <template #footer>
          <div class="btn-group flex-row-reverse">
            <template>
              <ProcessButton class="btn btn-primary ml-2" :status.sync="btnStatus" @click="confirmAddPages" type="submit">
                <template #loading>{{ $t("generals.loading") }}...</template>
                <template #success>{{ $t("generals.success") }}</template>
                <template #error>{{ $t("generals.error") }}</template>
                <template #default>{{ $t("group.addPage") }}</template>
              </ProcessButton>
            </template>

            <button class="btn btn btn-outline" @click="closeModalConfirmAddPages">{{ $t("generals.cancel") }}</button>
          </div>
        </template>
      </Modal>

      <!-- <Portal to="tooltips">
        <transition name="fade">
          <Tooltip :pointer="true" :width="'auto'" :delay="800" />
        </transition>
      </Portal> -->
    </div>
  </div>
</template>

<script>
import { ButtonCreatePage, FilterPage, GroupList } from "../components";
import { cloneDeep } from "@/shared";
import GpEmptyPage from "@/core/shared/GpEmptyPage";
import Pagination from "@/core/shared/essenstials/Pagination";
import TrialTooltipPlanVue from "@/modules/Pricing/components/TrialTooltipPlan.vue";
import GpTabs, { GpTab, GpTabContent } from "@/core/shared/GpTabs";
import Noti from "@/core/shared/base/Notification";
import { GpInputSearch } from "@/core/shared/GpForms";
import GpList, { GpListItem, GpListLoading } from "@/core/shared/GpList";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";

import GroupSettingsDropdown from "../components/GroupSettingsDropdown";

import ButtonAddPages from "../components/ButtonAddPages";
import AssignProductModal from "../components/AssignProductModal/AssignProductModal";
import RightSection from "@/modules/Shopify/components/RightSection.vue";
import LimitationPublishPage from "@/modules/Pricing/components/LimitationPublishPage.vue";
import processButton from "@/mixins/processButton.js";
import { LANDING_PAGE_EVENT, HOME_PAGE_EVENT, PRODUCT_PAGE_EVENT, COLLECTION_PAGE_EVENT, BLOG_POST_EVENT } from "@/config/constants/trackEventIds";

export default {
  name: "Pages",
  components: {
    GpTabs,
    GpTab,
    GpTabContent,
    GpEmptyPage,
    ButtonCreatePage,
    FilterPage,
    GpInputSearch,
    GroupList,
    GpList,
    GpListItem,
    GpListLoading,
    Pagination,
    GroupSettingsDropdown,
    ButtonAddPages,
    AssignProductModal,
    RightSection,
    Noti,
    TrialTooltipPlanVue,
    LimitationPublishPage
  },
  mixins: [processButton()],
  props: {
    type: String
  },
  data() {
    return {
      modals: {
        confirmAddPages: {
          active: false
        },
        addPages: {
          active: false
        },
        newGroup: {
          active: false
        }
      },
      textDefault: {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      },
      previousRoute: null,
      inRoute: false,
      // query: "",
      queryGroup: "",
      queryPage: "",
      activeTab: "pages",
      currentTabIndex: 0,
      groupPagination: {
        limit: 20,
        page: 1
      },
      paginateAddPages: {
        start: 0,
        limit: 10
      },

      group_selected: null,
      groupName: "",
      listType: "",
      querySearchPage: "",
      checkboxItems: [],

      selectedUnAssign: 0,
      allPagesAdd: [],
      querySearchAddItem: "",
      selectedTemplate: {
        id: 0,
        title: "",
        assigns: []
      },
      loadingList: false,
      loadingListRightSection: false,
      isOpenRightSection: false,
      runnerSearch: null,
      currentFilterGroup: "modified",
      currentFilterAddItems: "modified",
      currentFilterAddPages: "modified",
      alertText: "",
      indicatingSearchPage: false,
      img: "",
      messageEditShopify: false,
      runnerOriginalMessage: null
    };
  },
  computed: {
    ...mapState("page", {
      pagesList: "pages"
    }),
    ...mapState("account", {
      shopInfo: "shopInfo",
      permissions: "permissions"
    }),
    ...mapGetters("page", {
      sortedSubPages: "sortedSubPages",
      sortedArticlePages: "sortedArticlePages",
      sortedCollectionPages: "sortedCollectionPages",
      sortedHomePages: "sortedHomePages",
      sortedProductPages: "sortedProductPages",
      getAssignItems: "getAssignItems",
      getAssignsTotal: "getAssignsTotal" // total products/collections
    }),
    ...mapGetters("group", {
      groups: "groups"
    }),
    openOriginalMessage() {
      return this.$t("page.openOriginal");
    },
    disableUngroup() {
      let childItems = this.currentTypePages.filter(item => {
        if (item.page_group_id && item.page_group_id == this.group_selected.id) {
          return item;
        }
      });
      return !childItems || !childItems.length;
    },
    // Total Assign Items for default template
    totalItems() {
      if (["productpages", "collectionpages"].includes(this.type)) {
        let defaultTemplate = this.currentTypePages.find(e => e.published);
        if (!defaultTemplate) return null;
        // Mark 2
        let otherAssigns = this.itemsList.filter(e => {
          let suffix = "";
          if (e.template_suffix) {
            suffix = e.template_suffix;
          }
          let templateID = suffix.split("-");
          if (templateID && templateID.length == 3) {
            templateID = templateID[1];
          } else {
            templateID = null;
          }
          // Maybe we should check include "gem-" hmmm
          if (e.template_suffix && e.template_suffix.includes("gem-") && !e.template_suffix.includes(defaultTemplate.id) && templateID && this.templateExist(templateID)) {
            return e;
          }
        });
        return this.getAssignsTotal(this.type) - otherAssigns.length;
      }
      return null;
    },
    itemsList() {
      return this.getAssignItems(this.type);
    },
    currentTypeGroups() {
      return this.groups(this.type).map(x => {
        let item = { ...x };
        let pNames = this.currentTypePages
          .filter(x => x.page_group_id == item.id)
          .map(x => x.title)
          .join("[♠]");
        item.pagesName = pNames;
        return item;
      });
    },
    groupsTransform() {
      let start = (this.groupPagination.page - 1) * this.groupPagination.limit;
      const q = this.queryGroup.toLowerCase().trim();
      return this.currentTypeGroups
        .filter(e => {
          return e.name.toLowerCase().includes(q) || (e.pagesName && e.pagesName.toLowerCase().includes(q));
        })
        .sort((a, b) => {
          if (this.currentFilterGroup.includes("name")) {
            if (a && b && a.name && b.name) {
              return a.name.localeCompare(b.name);
            }
          }
          if (this.currentFilterGroup.includes("modified")) return new Date(a.updated_at) <= new Date(b.updated_at) ? 1 : -1;
        })
        .slice(start, start + this.groupPagination.limit);
    },
    filterType() {
      return this.currentTabIndex ? "group" : "page";
    },
    query() {
      return this.pagesList[this.type].query;
    },
    sortedPages() {
      let start = (this.pagination.page - 1) * this.pagination.limit;
      return this.currentTypePages.slice(start, start + this.pagination.limit);
    },
    pageDefaultTitle() {
      const pageDefault = this.sortedPages.find(item => item.published);
      if (pageDefault) {
        const title = pageDefault.title;
        if (this.textDefault[title]) {
          return this.textDefault[title];
        }
        return title;
      }
      return "";
    },
    currentTypePages() {
      switch (this.type) {
        case "subpages":
          return this.sortedSubPages;
        case "articlepages":
          return this.sortedArticlePages;
        case "collectionpages":
          return this.sortedCollectionPages;
        case "productpages":
          return this.sortedProductPages;
        case "homepages":
          return this.sortedHomePages;
        default:
          return this.sortedHomePages;
      }
    },
    totalPagesPagination() {
      return Math.ceil(this.currentTypePages.length / this.pagination.limit);
    },
    totalGroupsPagination() {
      return Math.ceil(this.groups(this.type).length / this.groupPagination.limit);
    },
    totalPages() {
      return this.pagesList[this.type].list.length;
    },
    currentPageType() {
      return this.pagesList[this.type];
    },
    currentPageTypeList() {
      let list = this.currentPageType.list;
      if (this.type == "productpages" || this.type == "collectionpages") {
        // let hasAssigns = false;
        // for (let i = 0; i < list.length; i++) {
        //   const item = list[i];
        //   if (item.hasOwnProperty("assigns")) {
        //     hasAssigns = true;
        //     break;
        //   }
        // }
        // if (!hasAssigns)
        this.reloadAssigns();
      }
      return list;
    },
    isEmptyPagesList() {
      return this.currentPageType.fetched && !(this.sortedPages && this.sortedPages.length) && this.currentPageTypeList.length == 0;
    },
    pagination() {
      return this.currentPageType.pagination;
    },
    slicePages() {
      let list = this.currentPageTypeList;

      list = list.filter(e => e.title.toLowerCase().includes(this.querySearchPage.trim().toLowerCase()));

      list = list.sort((a, b) => {
        if (this.currentFilterAddPages.includes("name")) {
          if (a && b && a.title && b.title) {
            return a.title.localeCompare(b.title);
          }
        }
        if (this.currentFilterAddPages.includes("modified")) return new Date(a.updated_at) <= new Date(b.updated_at) ? 1 : -1;
        if (this.currentFilterAddPages.includes("published")) return new Date(a.published_at) <= new Date(b.published_at) ? 1 : -1;
      });

      list = list.slice(this.paginateAddPages.start, this.paginateAddPages.start + this.paginateAddPages.limit);
      return list;
    },
    isOriginalShopifyPage(title) {
      return this.textDefault[title] ? true : false;
    }
  },
  watch: {
    type(newVal, oldVal) {
      if (newVal != oldVal) {
        this.fetch();
        this.updateGroupSelected(0);
        this.messageEditShopify = false;
        this.group_selected = null;
        this.currentTabIndex = 0;
        if (this.type == "productpages") {
          this.isOpenRightSection = false;
          this.preloadImage(this.publicPath + require("@/core/assets/gif/makeDefaultProduct.gif"), this.type);
        } else if (this.type == "collectionpages") {
          this.isOpenRightSection = false;
          this.preloadImage(this.publicPath + require("@/core/assets/gif/makeDefaultCollection.gif"), this.type);
        }
      }
    },
    totalPagesPagination(newVal, oldVal) {
      if (oldVal == 0) return;
      if (newVal != oldVal) {
        if (this.currentPageType.fetched) {
          let pagi = {
            page: this.pagination.page
          };
          if (this.pagination.page > newVal) pagi.page = newVal;
          if (pagi.page < 1) {
            pagi.page = 1;
          }
          this.updatePagesPagination({
            type: this.type,
            pagination: pagi
          });
        }
      }
    },
    totalGroupsPagination() {
      if (this.totalGroupsPagination < this.groupPagination.page) {
        this.groupPagination.page = this.totalGroupsPagination;
      }
      if (this.groupPagination.page == 0) {
        this.groupPagination.page = 1;
      }
      // if (oldVal == 0) return;
      // if (newVal != oldVal) {
      //   let pagi = {
      //     page: this.groupPagination.page
      //   };
      //   if (this.groupPagination.page > newVal) pagi.page = newVal;
      //   if (pagi.page < 1) {
      //     pagi.page = 1;
      //   }
      //   this.updatePagesPagination({
      //     type: this.type,
      //     pagination: pagi
      //   });
      // }
    },
    sortedPages: {
      deep: true,
      handler(newV, oldV) {
        if (!(this.type == "productpages" || this.type == "collectionpages")) return;
        if (newV == oldV || JSON.stringify(newV) == JSON.stringify(oldV)) return;
        this.onCheckPreviewLinks();
      }
    }
    // currentPageTypeList: {
    //   deep: true,
    //   // immediate: true,
    //   handler(newV, oldV) {
    //     if (newV == oldV || JSON.stringify(newV) == JSON.stringify(oldV))
    //       return;
    //     if (this.type == "productpages" || this.type == "collectionpages") {
    //       this.reloadAssigns();
    //     }
    //   }
    // }
  },
  created() {
    const APPLY_TIME = 1688688000000; // 2023/07/07
    if (new Date(this.shopInfo.createdAt).getTime() >= APPLY_TIME) {
      const currentRouterName = this.$route.name;
      const paramGemPagesV7 = {
        LandingPages: "/instant/landing-pages",
        HomePages: "/instant/home-pages",
        ProductPages: "/instant/product-pages",
        CollectionPages: "/instant/collection-pages",
        ArticlePages: "/instant/article-pages"
      };
      if (this.shopInfo.shopType.isGemPagesV7 || (this.shopInfo.shopType.isGemPagesMixed && currentRouterName == "LandingPages")) {
        this.$router.replace({ path: paramGemPagesV7[currentRouterName] });
      }
    }
    this.fetch();
    this.updateGroupSelected(0);
    this.group_selected = null;
    if (this.type == "productpages") {
      this.preloadImage(this.publicPath + require("@/core/assets/gif/makeDefaultProduct.gif"), this.type);
    } else if (this.type == "collectionpages") {
      this.preloadImage(this.publicPath + require("@/core/assets/gif/makeDefaultCollection.gif"), this.type);
    }
    this.$root.$on("onUngroupSuccess", () => {
      this.updateGroupSelected(0);
    });
  },
  mounted() {
    this.inRoute = true;
    this.updateGroupSelected(0);
    this.group_selected = null;
  },
  beforeDestroy() {
    this.inRoute = false;
    this.updateGroupSelected(0);
    this.group_selected = null;
  },
  methods: {
    ...mapActions("page", {
      fetchPages: "fetchPages",
      updatePagesPagination: "updatePagesPagination",
      updatePagesFilter: "updatePagesFilter",
      setGroupID: "setGroupID",
      fetchAllItems: "fetchAllItems",
      fetchAllAssignItems: "fetchAllAssignItems",
      createPageWithOneTap: "createPageWithOneTap"
    }),
    ...mapActions("group", {
      fetchGroups: "fetchGroups",
      createGroup: "createGroup"
    }),
    ...mapActions("common", {
      openLoading: "openLoading",
      trackEvent: "trackEvent"
    }),
    ...mapMutations("page", {
      mutateStoreQuery: "PAGE_UPDATE_QUERY",
      mutateStoreGroupSelected: "PAGE_UPDATE_GROUP_SELECTED",
      mutateJustUpdated: "PAGE_MUTATE_JUST_UPDATED"
    }),
    hoverRemoveUpdated(page) {
      let type = this.type;
      if (page.__justUpdated) {
        this.mutateJustUpdated({ id: page.id, type, value: undefined });
        this.$forceUpdate();
      }
    },
    onLeave() {
      this.runnerOriginalMessage && clearTimeout(this.runnerOriginalMessage);
      this.runnerOriginalMessage = setTimeout(() => {
        this.messageEditShopify = false;
      }, 10000);
    },
    onHover() {
      this.runnerOriginalMessage && clearTimeout(this.runnerOriginalMessage);
    },
    makedDefault(page) {
      this.selectedTemplate = page;
    },
    closeModalV2(type) {
      this.alertText = "";
      this.modals[type].active = false;
      this.groupName = "";
      this.resetStatus();
    },
    isModalActiveV2(type) {
      return this.modals[type].active;
    },
    openModalV2(type) {
      this.modals[type].active = true;
    },
    onChangeSearchAddPages() {
      this.paginateAddPages.start = 0;
      this.allPagesAdd = this.slicePages;
    },
    templateExist(templateID) {
      let list = this.currentPageType.list;
      for (let i = 0; i < list.length; i++) {
        if (list[i].id == templateID) {
          return true;
        }
      }
      return false;
    },

    selectedBorder(item) {
      if (this.type == "productpages" || this.type == "collectionpages") {
        if (item.id == this.selectedTemplate.id) {
          return true;
        }
      }
      return false;
    },

    isChecked(page) {
      return this.group_selected.id == page.page_group_id;
    },
    confirmAddPages() {
      this.doAddPages();
    },

    reloadAssigns() {
      if (this.type == "productpages" || this.type == "collectionpages") {
        this.currentPageType.list.forEach(e => {
          var assignsList = [];
          // Mark 1
          assignsList = this.itemsList.filter(el => {
            // if (el.title.toLowerCase().includes(this.querySearchAddItem.toLowerCase())) {
            // if (!el.checked) {
            this.$set(el, "checked", false);
            // }
            if (el) {
              let suffix = "";
              if (el.template_suffix && el.template_suffix.includes("gem-")) {
                suffix = el.template_suffix;
              }
              let templateID = suffix.split("-");
              if (templateID && templateID.length == 3) {
                templateID = templateID[1];
              } else {
                templateID = null;
              }
              // Nếu là default thì là ko có template_suffix hoặc assign template_suffix.includes(template.id)
              // Nếu không phải default thì chỉ lấy ra assign template_suffix.includes(template.id)
              if (e.published) {
                if (!suffix || templateID == e.id || !this.templateExist(templateID)) {
                  return el;
                }
              } else {
                if (templateID == e.id) {
                  return el;
                }
              }
            }
            // }
          });
          this.$set(e, "assigns", assignsList);
        });
      }
    },
    submitAddPages() {
      if (this.checkConflictAddPage()) {
        this.closeModalV2("addPages");
        this.openModalV2("confirmAddPages");
        return;
      }
      this.doAddPages();
    },
    doAddPages() {
      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      if (this.checkboxItems.length == 0) {
        this.closeModalAddPages();
        return;
      }
      this.setGroupID({
        data: this.checkboxItems,
        group_id: this.group_selected.id,
        pageType: this.type
      })
        .then(() => {
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });
          this.closeModalAddPages();
          this.closeModalConfirmAddPages();
          this.updateItemsCountInGroup();
        })
        .catch(() => {
          this.gSnackbarCommit({
            message: this.$t("status.error"),
            type: "error"
          });
          this.closeModalAddPages();
          this.closeModalConfirmAddPages();
        });
    },
    updateItemsCountInGroup() {
      this.groups(this.type).forEach(e => {
        this.$set(e, "count", this.currentPageTypeList.filter(p => p.page_group_id == e.id).length);
      });
    },
    checkConflictAddPage() {
      for (let i = 0; i < this.checkboxItems.length; i++) {
        let found = this.currentPageTypeList.find(el => el.id == this.checkboxItems[i].id);
        if (found && found.page_group_id && found.page_group_id != this.group_selected.id) {
          return true;
        }
      }
      return false;
    },
    doLoadMore() {
      this.paginateAddPages.start += this.paginateAddPages.limit;
      this.allPagesAdd = this.allPagesAdd.concat(this.slicePages);
    },
    checkedUpdate(val) {
      let foundIndex = this.checkboxItems.findIndex(e => e.id == val.id);
      if (foundIndex > -1) {
        if (val.value != this.checkboxItems[foundIndex].value) {
          this.checkboxItems[foundIndex].value = val.value;
        }
      } else {
        this.checkboxItems.push(val);
      }
    },
    onClickAddPages() {
      this.openModalV2("addPages");
      this.listType = "addPages";

      // Reset pages list in Add Pages modal
      this.checkboxItems = [];
      this.paginateAddPages.start = 0;
      this.allPagesAdd = this.allPagesAdd.filter(e => e.title.toLowerCase().includes(this.querySearchPage.trim().toLowerCase())).concat(this.slicePages);
    },
    onClickGroupItem(group) {
      if (group) {
        this.group_selected = group;
        this.updateGroupSelected(this.group_selected.id);
        this.currentTabIndex = 0;
      }
    },
    onTabChangeHandler(val) {
      this.queryGroup = "";
      this.queryPages({ value: "" });
      this.queryPage = "";
      this.group_selected = null;
      if (this.currentTabIndex != val && val == 1) {
        this.fetchGroups({
          pageType: this.type,
          onSuccess: () => {
            this.updateItemsCountInGroup();
            this.trackGroupViewedEvent();
          },
          onError: () => {}
        });
      } else {
        this.trackViewedEvent();
      }
      this.currentTabIndex = val;
    },
    onUngroupSuccess() {
      this.group_selected = null;
      this.currentTabIndex = 1;
    },
    fetch() {
      this.loadingList = true;
      this.loadingListRightSection = true;
      this.queryPage = this.currentPageType.query;
      this.fetchPages({
        type: this.type,
        shop: this.shopInfo.shopifyDomain,
        onSuccess: () => {
          if (!["productpages", "collectionpages"].includes(this.type)) {
            // Fetch Groups
            this.fetchGroups({
              pageType: this.type,
              onSuccess: () => {
                this.updateItemsCountInGroup();
              },
              onError: () => {}
            });
          }
          this.loadingList = false;

          // DO NOT show loading page when call below APIs
          // Only show loading on right sidebar section
          if (this.type == "productpages" || this.type == "collectionpages") {
            if (this.sortedPages[0] != undefined) {
              this.selectedTemplate = this.sortedPages[0];
            }
            let fetchAllAssignItems;
            let fetchAllItems;
            if (this.type == "collectionpages") {
              // Call api api/product/getAssignedProducts.html, getAssignedCollections.html
              fetchAllAssignItems = this.fetchAllAssignItems({
                shop: this.shopInfo.shopifyDomain,
                type: this.type
              });
              // Call api getProducts.html if current view is productpages or collectionpages
              fetchAllItems = this.fetchAllItems({
                shop: this.shopInfo.shopifyDomain,
                type: this.type
              });
            }

            Promise.all([fetchAllAssignItems, fetchAllItems])
              .then(() => {
                this.loadingListRightSection = false;
              })
              .catch(() => {
                this.loadingListRightSection = false;
              });
          }
          this.trackViewedEvent();
        }
      });
    },
    trackViewedEvent() {
      const templatePages = this.sortedPages.map((page, index) => {
        return { id: page.id, position: index + 1 };
      });

      this.trackEvent({
        event_id: this.viewedEventType(),
        properties: {
          list_type: "page",
          list_pagination: this.pagination.page,
          template_pages: templatePages
        }
      });
    },
    trackGroupViewedEvent() {
      const groups = this.groupsTransform.map((g, index) => {
        return { id: g.id, position: index + 1 };
      });

      this.trackEvent({
        event_id: this.viewedEventType(),
        properties: {
          list_type: "group",
          list_pagination: this.groupPagination.page,
          groups
        }
      });
    },
    createNewGroup() {
      if (this.groupName.trim() == "") {
        this.alertText = "Group name cannot be blank.";
        return;
      }
      // this.closeModalV2("newGroup");

      this.gSnackbarCommit({
        message: this.$t("status.processing"),
        type: "loading"
      });
      this.activeLoading();
      this.createGroup({
        pageType: this.type,
        name: this.groupName
      })
        .then(() => {
          this.gSnackbarCommit({
            message: this.$t("status.success"),
            type: "success"
          });
          this.activeSuccess();
          this.currentTabIndex = 1;
          this.closeModalV2("newGroup");
        })
        .catch(() => {
          this.gSnackbarCommit({
            message: this.$t("status.error"),
            type: "error"
          });
          this.activeError();

          this.closeModalV2("newGroup");
        });
    },
    toPage(page) {
      let pagi = {
        page: page
      };
      this.updatePagesPagination({
        type: this.type,
        pagination: pagi
      });

      this.trackViewedEvent();
    },
    toPageGroup(page) {
      this.groupPagination.page = page;
      this.trackGroupViewedEvent();
    },
    onClickFilter(filter) {
      // Filter for page
      if (this.filterType == "page") {
        this.updatePagesFilter({
          type: this.type,
          filter: filter
        });
        return;
      }

      // Filter for group
      this.currentFilterGroup = filter;
    },
    // eslint-disable-next-line no-unused-expressions
    onClickFilterAddPages(filter) {
      this.currentFilterAddPages = filter;
    },
    onClickFilterAddItems(filter) {
      this.currentFilterAddItems = filter;
    },
    openEditor(bool) {
      if (typeof bool == "object") {
        this.isOpenRightSection = true;
        this.$refs && this.$refs.rightSection && this.$refs.rightSection.resetSearch();
        this.selectedTemplate = bool;
        return;
      }
      if (bool) {
        // this.openLoading();
        // this.gSnackbarCommit({
        //   message: this.$t("generals.redirecting") + "...",
        //   type: "loading"
        // });
        this.gLoadingCommit({
          active: true,
          size: "large"
        });
      }
    },
    closeRightSection() {
      this.isOpenRightSection = false;
    },
    backToGroups() {
      this.group_selected = null;
      this.currentTabIndex = 1;
      this.updateGroupSelected(0);
      this.updateItemsCountInGroup();
    },
    onClickTemplatePage() {
      this.createPageWithOneTap({ type: this.type });
      return;
    },
    closeModalAddPages() {
      // Reset pages list in Add Pages modal
      this.paginateAddPages.start = 0;
      this.allPagesAdd = [];
      this.closeModalV2("addPages");
    },

    closeModalConfirmAddPages() {
      this.closeModalV2("confirmAddPages");
      this.checkboxItems = [];
    },

    queryPages({ value }) {
      this.indicatingSearchPage = true;
      if (!value || !value.trim()) {
        this.indicatingSearchPage = false;
      }
      this.runnerSearch && window.clearTimeout(this.runnerSearch);
      this.runnerSearch = window.setTimeout(() => {
        this.mutateStoreQuery({
          query: value,
          type: this.type
        });
        this.indicatingSearchPage = false;
      }, 200);
    },
    updateGroupSelected(value) {
      this.mutateStoreGroupSelected({
        group_id: value,
        type: this.type
      });
    },
    preloadImage(url) {
      this.toDataURL(url, dataUrl => {
        this.img = dataUrl;
      });
    },
    toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
        var reader = new FileReader();
        reader.onloadend = function() {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    },
    preventOpenEditor(e) {
      if (e.type == "template-index" || e.type == "template-product" || e.type == "template-collection") {
        this.messageEditShopify = true;
        this.runnerOriginalMessage && clearTimeout(this.runnerOriginalMessage);
        this.runnerOriginalMessage = setTimeout(() => {
          this.messageEditShopify = false;
        }, 10000);
      }
    },
    viewedEventType() {
      switch (this.type) {
        case "subpages":
          return LANDING_PAGE_EVENT.VIEWED;
        case "articlepages":
          return BLOG_POST_EVENT.VIEWED;
        case "homepages":
          return HOME_PAGE_EVENT.VIEWED;
        case "productpages":
          return PRODUCT_PAGE_EVENT.VIEWED;
        case "collectionpages":
          return COLLECTION_PAGE_EVENT.VIEWED;
      }
    },
    onCheckPreviewLinks() {
      const sortedPages = cloneDeep(this.sortedPages);
      const pageNoPreviewOrViewLive = [];
      sortedPages.forEach(item => {
        if (!item.previewUrl) {
          pageNoPreviewOrViewLive.push({
            id: item.id,
            type: item.type
          });
        }
      });
      if (pageNoPreviewOrViewLive.length) {
        const payload = { noPreviewOrViewLivePages: pageNoPreviewOrViewLive, type: this.type };
        this.$store.dispatch("page/fetchPreviewLink", payload);
      }
      return;
    },
    updateDocumentTitle() {
      const pageTypeMap = {
        homepages: "Home Pages",
        subpages: "Landing Pages",
        productpages: "Product Pages",
        collectionpages: "Collection Pages",
        articlepages: "Article Pages"
      };

      const pageType = pageTypeMap[this.type] || "Dashboard";
      document.title = `${pageType} - GemPages`;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;

      vm.updateDocumentTitle();

      if (!vm.permissions[vm.type]) {
        if (from.name != "Pricing") vm.$router.replace({ name: "Pricing" });
        else vm.$router.replace({ name: "Dashboard" });
      }
      return true;
    });
  },
  beforeRouteLeave(to, from, next) {
    const allowedRoutes = ["LandingPages", "HomePages", "ProductPages", "CollectionPages", "ArticlePages"];

    const shouldResetDocumentTitle = !allowedRoutes.includes(to.name);

    if (shouldResetDocumentTitle) {
      document.title = "Dashboard - GemPages";
    }

    next();
  }
};
</script>

<style lang="scss" scoped>
.subpage-body {
  display: flex;
  flex-direction: column;
  width: 100%;
}

::v-deep .filter-dropdown {
  background: none;
  display: flex;
}

::v-deep .dropdown {
  width: 168px !important;
}

::v-deep .gp-tabs {
  .gp-tabs-nav {
    &:after {
      content: unset;
    }
  }
}

.page-search {
  min-width: 312px;

  @media (max-width: 1280px) {
    min-width: 230px;
  }

  .gp-input-search {
    @media (max-width: 1280px) {
      width: 230px !important;
    }
  }
}

.page-filter {
  @include flex-center;

  padding: 4px;
  border-radius: $radius;
  @include trans-all;

  &:hover {
    ::v-deep .dropdown_toggle {
      > p,
      > i {
        @include trans-all;
        color: $mono3;
      }
    }
  }

  ::v-deep .dropdown_toggle {
    border: none;
    margin: 0;
    padding: 0;
    width: auto;
    outline: none;
    overflow: visible;
    background: transparent;
    color: inherit;
    font: inherit;

    .icon.icon-arrow-up {
      @include trans-all;
    }

    &.active {
      .icon.icon-arrow-up {
        transform: rotate(180deg);
      }
    }
  }
}

.create-buttons,
.add-pages {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;

  .create-group {
    padding: 10px;
    min-height: 40px;
    max-height: 40px;
    min-width: 40px;
    max-width: 40px;
    border-radius: $radius;
    box-sizing: border-box;
    background: $light1;

    .icon {
      font-size: 20px;
    }

    @include trans-all;

    &:hover {
      background: $textDarkModeHigh;
    }
  }
}

#subpages {
  .breadcrum {
    cursor: pointer;
  }
  .section {
    .bar {
      // border-bottom: 1px solid $grey3;
      .page-cannot-edit {
        padding: 10px 16px;
        border-radius: $radius;
        background: rgba(255, 187, 28, 0.5);
        position: relative;

        &::after {
          content: "";
          position: absolute;
          right: 10%;
          top: 100%;
          width: 0;
          height: 0;
          border-left: 8px solid transparent;
          border-right: 8px solid transparent;
          border-top: 8px solid rgba(255, 187, 28, 0.5);
        }
      }

      .page-tab {
        display: flex;
        border-bottom: 1px solid transparent;
      }

      .tab {
        display: flex;
        // align-items: flex-end;

        .tab-item {
          @include trans-all;
          // padding-bottom: 15px;
          cursor: pointer;
          position: relative;

          ::v-deep &-filter {
            button {
              border: none;
              margin: 0;
              padding: 0;
              width: auto;
              outline: none;
              overflow: visible;

              background: transparent;

              /* inherit font & color from ancestor */
              color: inherit;
              font: inherit;
            }
          }

          p,
          svg {
            margin-right: 5px;
          }

          &:not(:last-child) {
            margin-right: 30px;
          }
        }
      }
    }
  }
}

.group-settings {
  ::v-deep .gp_dropdown_list {
    width: 228px;
  }

  ::v-deep .gp_dropdown-button {
    padding: 8px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
}

::v-deep .gp-tabs-nav {
  flex: 0;
}

.selected-border {
  // border: 1px solid $dark3 !important;
  box-shadow: 0 0 0 1px $dark3;

  &::after {
    position: absolute;
    font-family: "gemicon" !important;
    content: "\e90e";
    right: -20px;
    animation-name: selected-cursor;
    animation-duration: 3s;
    animation-iteration-count: infinite;
  }

  @keyframes selected-cursor {
    50% {
      right: -25px;
    }
  }
}
.disabled-when-campaign {
  background-color: $light2;
}

.breadcrumb-groupname {
  max-width: 280px;

  color: $cSecondary4;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

.add-item-title {
  width: 220px;

  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden !important;
  text-overflow: ellipsis;
}

@media screen and (max-width: 1279px) {
  .group-settings {
    ::v-deep .gp_dropdown_list {
      // right: 0;
      transform: translateX(50%);
    }
  }
}

.--just-updated {
  border: 2px solid $accent-yellow;
  overflow: hidden;
  filter: drop-shadow(0px 12px 38px rgba(34, 34, 34, 0.0393604)), drop-shadow(0px 5.01331px 15.8755px rgba(34, 34, 34, 0.056545)), drop-shadow(0px 2.68036px 8.4878px rgba(34, 34, 34, 0.07)), drop-shadow(0px 1.50259px 4.75819px rgba(34, 34, 34, 0.083455)), drop-shadow(0px 0.798012px 2.52704px rgba(34, 34, 34, 0.10064)), drop-shadow(0px 0.332071px 1.05156px rgba(34, 34, 34, 0.14));
}

.gf_btn__action-group {
  ::v-deep .snack-loading {
    font-size: 16px;
    width: 16px;
    height: 16px;
    animation: spin 1s linear infinite;
  }
}
</style>
